import React from 'react';
import PageTitle from '../PageTitle';
import { Helmet } from 'react-helmet';

const Gallery = () => {
  const images = [
    './images/before-after-11.jpeg',
    './images/before-after-12.jpeg',
    './images/before-after-5.jpeg',
    './images/before-after-4.webp',
    './images/before-after-10.jpeg',
    './images/before-after-1.webp',
    './images/before-after-2.webp',
    './images/before-after-3.webp',
    './images/before-after-6.jpeg',
    './images/before-after-7.jpeg',
    './images/before-after-8.jpeg',
    './images/before-after-9.jpeg',
    './images/02-22-2026/Before After drawer.jpg',
    './images/02-22-2026/Before after washing machine.jpg',
    './images/02-22-2026/Door Marker Before After 2025.jpg',
    './images/02-22-2026/Porcelain Sink Before After 2025.jpg',
    './images/02-22-2026/Wood Banister Before After 2025.jpg',
    './images/02-22-2026/before after toilet bowl build up.jpg',
    './images/02-22-2026/Before After Carpet.jpg',
  ];
  return (
    <>
      <Helmet>
        <title>I'm Your Huckleberry | Gallery</title>
      </Helmet>
      <PageTitle title={'Gallery'}>
        <p className="text-center text-white col-12 col-md-12 mx-auto ">
          Explore our gallery to see before-and-after photos of our cleaning services and the
          quality results we deliver for homes and businesses.
        </p>
      </PageTitle>
      <div className="container mt-4">
        <div className="row">
          <div className="col-12 col-lg-10 mx-auto">
            <div className="container">
              <div className="row">
                {images.map((image, index) => (
                  <div className="text-center mb-4 col-12 col-md-6" key={index}>
                    <img
                      src={image}
                      alt={`Gallery Image ${index + 1}`}
                      className="img-fluid rounded shadow"
                      style={{ maxWidth: '100%', height: 'auto' }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gallery;
